"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultLocale = exports.getAllLocales = exports.getLocales = exports.getDefaultLanguage = exports.getLanguages = exports.getAllLanguages = void 0;
const basic_types_1 = require("../constants/generated/basic-types");
const get_all_markets_1 = require("./get-all-markets");
const get_market_1 = require("./get-market");
const getAllLanguages = (brand) => {
    const supportedBrand = (0, basic_types_1.asBrand)(brand);
    if (!supportedBrand) {
        return;
    }
    return get_all_markets_1.allMarkets[supportedBrand].reduce((acc, m) => {
        return [...new Set([...acc, ...m.country.languages])];
    }, []);
};
exports.getAllLanguages = getAllLanguages;
const getLanguages = (brand, iso2) => {
    const market = (0, get_market_1.getMarket)(brand, iso2);
    return market === null || market === void 0 ? void 0 : market.country.languages;
};
exports.getLanguages = getLanguages;
const getDefaultLanguage = (brand, iso2) => {
    const market = (0, get_market_1.getMarket)(brand, iso2);
    return market === null || market === void 0 ? void 0 : market.country.defaultLanguage;
};
exports.getDefaultLanguage = getDefaultLanguage;
const getLocales = (brand, iso2) => {
    const market = (0, get_market_1.getMarket)(brand, iso2);
    return market === null || market === void 0 ? void 0 : market.country.locales;
};
exports.getLocales = getLocales;
const getAllLocales = (brand) => {
    const supportedBrand = (0, basic_types_1.asBrand)(brand);
    if (!supportedBrand) {
        return;
    }
    return get_all_markets_1.allMarkets[supportedBrand].reduce((acc, m) => {
        return [...new Set([...acc, ...m.country.locales])];
    }, []);
};
exports.getAllLocales = getAllLocales;
const getDefaultLocale = (brand, iso2) => {
    const market = (0, get_market_1.getMarket)(brand, iso2);
    return market === null || market === void 0 ? void 0 : market.country.defaultLocale;
};
exports.getDefaultLocale = getDefaultLocale;
